import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import {
  requestVisitNotes,
  requestAlertLimits,
  setView,
  requestICDLookup,
} from '../../../store/visit-notes/VisitNotesActions';

import ClinicActivityLayout from '../components/ClinicActivityLayout';
import { hostTitle } from '../../../config/ui';

class ClinicActivity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotes: false,
      selectedNote: null,
    };
  }

  componentWillMount() {
    this.props.setView('ALL');
    if (!this.props.limits) {
      this.props.getAlertLimits();
    }
    if (!this.props.lookups.icd) {
      this.props.getICDLookup(this.props.currentUser.queryParams.tenantId);
    }
  }

  fetchNotes = (
    page = 0,
    perPage = 25,
    order = 'desc dateOfService',
    search = '',
    filters = '',
    params = {},
  ) => {
    return this.props.getVisitNotes({
      offset: page * perPage,
      limit: perPage,
      order,
      search,
      filters,
      ...params,
      ...this.props.currentUser.queryParams,
    });
  };

  render() {
    const { data, isLoading, limits, lookups, ...otherProps } = this.props;
    return (
      <div>
        <Helmet title={`Clinic Activity – ${hostTitle()}`} />
        <ClinicActivityLayout
          view="ALL"
          title="All Clinic Activity"
          fetchNotes={this.fetchNotes}
          limits={limits}
          lookups={lookups}
          data={data}
          isLoading={isLoading}
          {...otherProps}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.visitNotes, currentUser: state.currentUser }),
  (dispatch) => ({
    getVisitNotes: (params) => dispatch(requestVisitNotes(params)),
    getAlertLimits: () => dispatch(requestAlertLimits()),
    getICDLookup: (tenantId) => dispatch(requestICDLookup(tenantId)),
    setView: (view) => dispatch(setView(view)),
  }),
)(ClinicActivity);



// WEBPACK FOOTER //
// ./src/routes/management/containers/ClinicActivity.js